import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { userSelector } from '../../features/user/userSlice';

import api from '../../services/api';
import apiErrorFormatter from '../../services/apiErrorFormatter';

import MaintenanceTask from './MaintenanceTask';

import LinearProgress from '@mui/material/LinearProgress';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
// import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';

// import RefreshIcon from '@mui/icons-material/Refresh';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function MaintenanceTaskList() {
  const { t } = useTranslation('maintenance');

  const { user } = useSelector(userSelector);
  const maintenanceTaskListRefreshTimeSeconds =
    user?.maintenanceTaskListRefreshTimeSeconds > 0
      ? user?.maintenanceTaskListRefreshTimeSeconds
      : 10;
  const plantId = user?.plant?.id > 0 ? user?.plant?.id : 0;

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);

  const [elapsedTime, setElapsedTime] = useState(0);
  const [progress, setProgress] = useState(0);

  const [maintenanceTasks, setMaintenanceTasks] = useState([]);

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      setElapsedTime((prevElapsedTime) =>
        prevElapsedTime < maintenanceTaskListRefreshTimeSeconds
          ? prevElapsedTime + 1
          : 0
      );
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setProgress(
      Math.trunc((elapsedTime / maintenanceTaskListRefreshTimeSeconds) * 100)
    );
    if (elapsedTime === maintenanceTaskListRefreshTimeSeconds) {
      getData();
    }
  }, [elapsedTime]);

  const getData = async () => {
    if (!loading) {
      setLoading(true);
      setErrors([]);
      await api
        .get('/maintenance/maintenance-tasks', { params: { plantId: plantId } })
        .then(
          (res) => {
            setMaintenanceTasks(res?.data);
            setLoading(false);
          },
          (err) => {
            setMaintenanceTasks([]);
            setErrors(apiErrorFormatter(err));
            setLoading(false);
          }
        );
    }
  };

  return (
    <Container sx={{ mt: 1, mb: 2 }} maxWidth="false">
      <Divider>{t('maintenance_tasks')}</Divider>
      {/* <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {Number(maintenanceTaskListRefreshTimeSeconds - elapsedTime) > 0
          ? t('common:updating_in_seconds', {
              count: Number(
                maintenanceTaskListRefreshTimeSeconds - elapsedTime
              ),
            })
          : t('common:updating')}
      </Typography> */}
      <LinearProgress variant="determinate" value={progress} />
      {/* <Paper sx={{ mb: 5, p: 1, textAlign: 'center' }} variant="outlined">
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="contained"
            sx={{ px: 4, py: 2 }}
            startIcon={<ArrowBackIcon />}
            component={RouterLink}
            to=".."
            relative="path"
          >
            {t('common:back')}
          </Button>
          <Button
            variant="contained"
            sx={{ px: 4, py: 2 }}
            startIcon={<RefreshIcon />}
            component={RouterLink}
            onClick={getData}
          >
            {t('common:refresh')}
          </Button>
        </Box>
      </Paper> */}
      {errors.length > 0 ? (
        <Box>
          {errors
            .slice()
            .reverse()
            .map((error) => (
              <Box key={error} mt={1}>
                <Alert variant="outlined" severity="error">
                  {t(error)}
                </Alert>
              </Box>
            ))}
        </Box>
      ) : (
        // <Paper
        //   sx={{
        //     p: 1,
        //     textAlign: 'center',
        //   }}
        //   variant="outlined"
        // >
        <Box
          sx={{
            // border: '1px solid red',
            p: 1,
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            // justifyContent: 'space-around',
            // justifyContent: 'stretch',
            // justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          {maintenanceTasks?.map((maintenanceTask) => (
            <MaintenanceTask
              key={maintenanceTask?.id}
              maintenanceTask={maintenanceTask}
            />
          ))}
          {/* <Box
              sx={{
                flexGrow: 1,
                flexBasis: '240px',
                bgcolor: 'coral',
                // visibility: 'hidden',
              }}
            >
              a
            </Box> */}
        </Box>
        // </Paper>
      )}
    </Container>
  );
}

export default MaintenanceTaskList;
